































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';

@Component
export default class DropdownCheckbox extends Vue {
  @Prop(Array) private arraySelect: Array<string>;
  @Prop(Array) private arrayExclude: Array<string>;
  @Prop(String) private nameDropdown: string;
  @Prop(Boolean) private isActive?: Boolean;
  @Prop(String) private _id?: string;
  @Prop(Number) private index?: number;
  isCheckbox: Boolean = false;
  checkedNames: Array<string>;

  private arraySelected: Array<number> = new Array();

  private get arraySelectFilter(): any {
    if (this.arrayExclude === undefined || this.arrayExclude.length === 0)
      return this.arraySelect;

    let filteredArray = this.arraySelect!.filter((item: any) => {
      let found = false;
      this.arrayExclude.forEach((ex: any) => {
        if (item._id === ex._id) found = true;
      });
      return !found;
    });
    return filteredArray.sort(function(a: any, b: any): any {
      if (a.name && b.name) return a.name.localeCompare(b.name);
    });
  }

  // event for open Dropdown and give focus
  public openCheckbox() {
    this.isCheckbox = true;
    const dropDown: HTMLElement = this.$refs.dropDown as HTMLElement;
    if (dropDown) dropDown.focus();
  }

  // event for close Dropdown
  public closeCheckbox() {
    this.isCheckbox = false;
  }

  @Emit('addBox')
  addBox(payload: Object) {
    return payload;
  }

  // event for delete Dropdown
  public deleteBox() {
    let payload = {
      index: this.index,
      _id: this._id,
    };
  }

  // function for select and unselect element in the dropdown
  public onSelect(index: number, select: any) {
    if (this.arraySelected.indexOf(index) > -1) {
      this.arraySelected.splice(this.arraySelected.indexOf(index), 1);
    } else {
      if (this._id) {
        let payload = {
          select: select,
          _id: this._id,
        };
        this.addBox(payload);
      } else {
        let payload = {
          select: select,
        };
        this.addBox(payload);
      }
    }
  }
}
